module.exports = __webpack_public_path__ + "img/android.eca417b2.png";